<template>
	<modal name="control-settings" :width="300" :height="400">
		<div id="control-settings-modal">
			<h1>{{ $t('controlSettingsModal.title') }}</h1>
			<IconTimes class="close-modal" @click.native="$modal.hide('control-settings')" />
			<h2>Kurzorové šipky nahoru a dolů</h2>
			<select v-model="arrowKeysUpDown">
				<option v-for="option in arrowKeysUpDownOptions" :value="option.value" :key="option.value">
					{{ option.text }}
				</option>
			</select>
		</div>
	</modal>
</template>

<script>
	import { mapState } from "vuex";
	import IconTimes from "@/components/icons/IconTimes";
	import {
		ARROW_KEYS_UP_DOWN,
		ARROW_KEYS_UP_DOWN__SCROLL_SONG,
		ARROW_KEYS_UP_DOWN__SWITCH_SONGS,
		ControlService
	} from "@/services/ControlService";

	export default {
		components: {
			IconTimes
		},
		data() {
			return {
				arrowKeysUpDownBuff: undefined
			}
		},
		computed: {
			...mapState([ "currentUser", "songs", "networkOnline" ]),
			arrowKeysUpDownOptions() {
				return [
					{ value: ARROW_KEYS_UP_DOWN__SWITCH_SONGS, text: "Přeskakovat písničky" },
					{ value: ARROW_KEYS_UP_DOWN__SCROLL_SONG, text: "Scrollovat písničku" }
				]
			},
			arrowKeysUpDown: {
				get() {
					return this.arrowKeysUpDownBuff
				},
				set(value) {
					this.arrowKeysUpDownBuff = value
					ControlService.setSettings(ARROW_KEYS_UP_DOWN, value)
				}
			}
		},
		mounted() {
			this.arrowKeysUpDownBuff = ControlService.getSettings(ARROW_KEYS_UP_DOWN)
		}
	}
</script>

<style lang="scss" scoped>
	#control-settings-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-weight: 300;

		.close-modal {
			fill: white;
			width: 20px;
			opacity: 0.5;
			position: absolute;
			top: 20px;
			right: 20px;
			cursor: pointer;

			&:hover {
				opacity: 1;
			}
		}

		h1 {
			margin: 0;
			padding: 20px;
			font-size: 1.4em;
			font-weight: 100;
		}

		h2 {
			margin: 0;
			padding: 10px 20px 0 20px;
			font-size: 1.1em;
			font-weight: 100;
		}

		p {
			margin: 0 20px 20px 20px;
		}

		select {
			margin: 10px 20px;
			padding: 10px 10px;
			width: auto;
			color: rgba(255, 255, 255, 0.8);
			background-color: rgba(255, 255, 255, 0.21);
			border: 0;
		}

		button {
			font-weight: 100;
			margin: 5px 20px;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #356173;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 260px;

			&:hover {
				background-color: #2f4f5f;
			}

			&:focus {
				outline: none;
			}

			&.button-delete-account {
				margin-top: 40px;
				background-color: #ac4b6c;
				line-height: 35px;

				&:hover {
					background-color: #883b55;
				}
			}
		}

	}
</style>
